module.exports = __webpack_public_path__ + "img/beer_id-19.07f6d137.png";